// Короткая выжимка `componentStack` для отчёта об ошибке маршрута.
//
// Зачем: Hawk обрезает строку контекста, и от стека компонентов доезжают три
// первых кадра — `div`, анонимный кадр radix и `CollapsibleContentImpl`
// (OXEM-841). Это кадры места падения, а не того, КТО рендерил: наши компоненты
// лежат глубже и до отчёта не доживают. Полный стек уходит как раньше, а рядом —
// список только наших кадров, который в обрезку не попадает.
//
// Имена наших компонентов в проде минифицированы, поэтому к имени добавляется
// чанк: по нему (`rhythm-…`, `main-…`) уже видно, из какого места кадр.

/** Сколько наших кадров отправлять. Дальше — корень приложения, он одинаков. */
const MAX_APP_FRAMES = 12;

/** `    at Name (https://…/assets/chunk-HASH.js:1:234)` или `    at https://…` */
const FRAME_RE = /^\s*at\s+(?:(\S+)\s+\((.+)\)|(\S+))\s*$/;

/** Имя чанка без хеша: `vendor-radix-T_SWolGl.js:1:30384` → `vendor-radix`. */
function chunkName(location: string): string | null {
	const file = location.split("/").at(-1)?.split(":")[0];
	if (!file?.endsWith(".js")) return null;
	return file.slice(0, -".js".length).replace(/-[\w-]{8}$/, "");
}

/**
 * Наши кадры стека компонентов — `Имя@чанк`, от места падения к корню.
 * Кадры вендорных чанков и хост-элементы (`div`, `<anonymous>`) отбрасываются.
 */
export function appComponentFrames(componentStack: string | null | undefined): string[] {
	if (!componentStack) return [];
	const frames: string[] = [];
	for (const line of componentStack.split("\n")) {
		const match = FRAME_RE.exec(line);
		if (!match) continue;
		const name = match[1] ?? "anonymous";
		const chunk = chunkName(match[2] ?? match[3] ?? "");
		if (!chunk || chunk.startsWith("vendor-")) continue;
		frames.push(`${name}@${chunk}`);
		if (frames.length === MAX_APP_FRAMES) break;
	}
	return frames;
}
